import clsx from 'clsx';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import Button, { ButtonProps, ButtonVariant } from '../button/Button.component';

interface SignUpButtonProps extends ButtonProps {
  className?: string;
  colorScheme?: ButtonVariant;
  label: string;
  onApply?: () => void;
  jobPositionAttributes?: Record<string, unknown>;
}

const SignUpButton: React.FC<SignUpButtonProps> = ({ label, className, colorScheme, onApply, ...rest }) => (
  <Button className={twMerge(clsx('px-8 py-3 xl:px-12', className))} colorScheme={colorScheme} label={label} onClick={onApply} {...rest} />
);

export default SignUpButton;
